const selectors = {
  cardCTA: "card-cta-component",
  cardLink: "card-link",
  spacer: "card-body-spacer",
  image: "card-image",
  title: "card-title",
};
export default selectors;
